export default __webpack_public_path__ + "static/media/keyservice1.0176a881.png";